export const dailyAllowanceFeatureKey = 'dailyAllowance';
